import VueApollo from 'vue-apollo'
import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from 'apollo-cache-inmemory'
import {ApolloLink} from 'apollo-link'
import store from './store/index'
import { onError } from "@apollo/client/link/error";
import Cookies from "js-cookie"

const customFetch = (uri, options) => {
  const id_token = store.state.oidcStore.id_token;
  return fetch(uri + '?id_token_hint=' + id_token, options);
}

// HTTP connection to the API
var httpLink = createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.KNOWLEDGE_URL,
})
var otherHttpLink=createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.TASKAPI_URL+'/graphql',
})

var appcenterLink = createHttpLink({
  uri: window.commonApi.APPCENTER_URL,
  fetch: customFetch,
})

var noLoginLink = createHttpLink({
  uri: window.commonApi.APPCENTER_ANONYMITY_URL
})

var manageHttpLink=createHttpLink({
  // You should use an absolute URL here
  uri:window.commonApi.BUS_URL,
})

var traceHttpLink = createHttpLink({
  uri: window.commonApi.TRACE_URL,
  fetch: customFetch,
})

// Cache implementation
var cache = new InMemoryCache({
	dataIdFromObject:o=>{o.id?`${o.__typename}-${o.id}`:`${o.__typename}-${o.cursor}`},
})

const errorLink = onError((props) => {
  const { graphQLErrors, networkError } = props;
  if (graphQLErrors && graphQLErrors.length) {

    if (JSON.stringify(graphQLErrors || {}).indexOf("OIDC_BC_LOGOUT") !== -1) {
      store.dispatch("oidcStore/signOutOidc");
    }

    if (JSON.stringify(graphQLErrors || {}).indexOf("ACCESS_TOKEN_INVALID") !== -1) {
      store.dispatch("oidcStore/oidcCallback");
    }
  }
});

var middlewareLink = new ApolloLink((operation, forward) => {
const token =store.state.oidcStore.access_token;
operation.setContext({
    headers: {
      Authorization: `Bearer ${token}` || null,
    }
})
return forward(operation)
})

var defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};
var linkStr=middlewareLink.concat(httpLink);
// var linkStr=httpLink;
var apolloClient = new ApolloClient({
  link:linkStr,
  cache:cache
})

var otherLinkStr=middlewareLink.concat(otherHttpLink);
var otherApolloClient = new ApolloClient({
  link:otherLinkStr,
  cache:cache
})

var manageLinkStr=middlewareLink.concat(manageHttpLink);
var manageApolloClient = new ApolloClient({
  link:manageLinkStr,
  cache:cache
})

var appcenterLinkStr = middlewareLink.concat(appcenterLink);
var appcenterApolloClient = new ApolloClient({
    link: errorLink.concat(appcenterLinkStr),
    cache: cache
})

var noLoginApolloClient = new ApolloClient({
  link: noLoginLink,
  cache: cache
})

var traceLinkStr = middlewareLink.concat(traceHttpLink);
var traceApolloClient = new ApolloClient({
    link: errorLink.concat(traceLinkStr),
    cache: cache
})

window.apolloProvider = new VueApollo({

	clients: {
    	api:apolloClient,
    	other:otherApolloClient,
    	manage:manageApolloClient,
      appcenter:appcenterApolloClient,
      nologin: noLoginApolloClient,
      trace: traceApolloClient
	},
	defaultClient:apolloClient
})


export default apolloProvider



// WEBPACK FOOTER //
// ./src/apolloConfig.js